import React, {Component} from 'react';
import Spinner from '../../components/UI/Spinner/Spinner';

class Dashboard extends Component {
    state = {
        loading: true
    };
    hideSpinner = () => {
        this.setState({
            loading: false
        });
    };
    render() {
        return (
            <div className="Dashboard">
                <div className="row">
                    <div className="col-md-12">
                        <iframe
                            src={"https://www.foodzaps.com/apk/index.php"}
                            width="100%"
                            height="820"
                            onLoad={this.hideSpinner}
                            frameBorder="0"
                            marginHeight="0"
                            marginWidth="0"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default Dashboard;